import AxiosClient from "../../../services/axios.services";

class MetricByFactorServices {
  getMetricByFactor = (params) =>
    AxiosClient.get("/api/app/evaluacion_metrica_factor/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getMetricByFactorById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_metrica_factor/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveMetricByFactor = (data) =>
    AxiosClient.post("/api/app/evaluacion_metrica_factor/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editMetricByFactor = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_metrica_factor/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteMetricByFactor = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_metrica_factor/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new MetricByFactorServices();
